import {
  FETCH_GMINY_REQUEST,
  FETCH_GMINY_SUCCESS,
  FETCH_GMINY_FAILURE,
  CHANGE_GMINA_WYBIERZ,
} from '../constants';

const gminyInitialState = {
  gminy: null,
  areGminyFetched: false,
  areGminyFetching: false,
  wybranaGmina: null,
};

const gminyRequest = (state) => ({
  ...state,
  areGminyFetching: true,
});
const gminySuccess = (state, action) => ({
  ...state,
  areGminyFetching: false,
  areGminyFetched: true,
  gminy: action.payload.gminy,
});
const gminyFailure = (state) => ({
  ...state,
  areGminyFetching: false,
  areGminyFetched: false,
});
const gminaWybierz = (state, gmina) => ({
  ...state,
  wybranaGmina: gmina,
});

export default function reducer(state = gminyInitialState, action) {
  return ({
    [FETCH_GMINY_REQUEST]: gminyRequest,
    [FETCH_GMINY_SUCCESS]: gminySuccess,
    [FETCH_GMINY_FAILURE]: gminyFailure,
    [CHANGE_GMINA_WYBIERZ]: gminaWybierz,
  }[action.type] || (s => s)) (state, action);
}



// WEBPACK FOOTER //
// src/reducers/gminy.js